(function () {
  var storageKey = 'aoy_original_inquiry_attribution';
  var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  try {
    var params = new URLSearchParams(window.location.search);
    var stored = {};
    var existing = window.sessionStorage.getItem(storageKey);
    if (existing) stored = JSON.parse(existing) || {};

    var changed = false;
    keys.forEach(function (key) {
      if (!params.has(key)) return;
      stored[key] = params.get(key) || '';
      changed = true;
    });

    if (changed) window.sessionStorage.setItem(storageKey, JSON.stringify(stored));
  } catch (error) {
    // Attribution is best-effort; storage restrictions must never block browsing.
  }
})();
